import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { MaskedLine } from "./Reveal";

const PageHero = ({ image, eyebrow, lines, subtitle, dark = true, height = "h-[70vh]", testId = "page-hero" }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [0, 140]);

  return (
    <section ref={ref} className={`relative ${height} min-h-[480px] overflow-hidden flex items-end`} data-testid={testId}>
      {image && (
        <motion.div className="absolute inset-0" style={{ y }}>
          <img src={image} alt="" className="hero-zoom w-full h-[115%] object-cover" />
        </motion.div>
      )}
      <div className={`absolute inset-0 ${dark ? "bg-gradient-to-t from-black/85 via-black/35 to-black/30" : "bg-gradient-to-t from-[#F7F5F0] via-transparent to-transparent"}`} />
      <div className="relative max-w-[1440px] mx-auto px-6 lg:px-10 pb-16 lg:pb-20 w-full">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.9, delay: 0.2 }}
          className="flex items-center gap-4 mb-6"
        >
          <span className="h-px w-12 bg-[#C5A059]" />
          <span className="text-[11px] tracking-[0.3em] uppercase font-medium text-[#C5A059]">{eyebrow}</span>
        </motion.div>
        <h1 className={`font-serif-display font-normal tracking-tight leading-[1.06] text-4xl sm:text-5xl lg:text-6xl ${dark ? "text-[#F7F5F0]" : "text-[#1C1B18]"}`}>
          {lines.map((line, i) => (
            <MaskedLine key={i} delay={0.3 + i * 0.14} immediate>{line}</MaskedLine>
          ))}
        </h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.9 }}
            className={`mt-6 max-w-xl text-base sm:text-lg leading-relaxed ${dark ? "text-[#F7F5F0]/75" : "text-[#666157]"}`}
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
};

export default PageHero;
